module.exports = "/_next/static/images/f28237c5dd2a537d18e705b7271bd875-app-avatar-4x.png";